<template>
	<div class="feedback-content">
		<div class="ss-container">
			<div class="feedback-title">志愿者信息</div>
			<div class="feedback-input-box">
				<div class="feedback-row">
					<div class="feedback-input-title"><span class="color-error">*</span>姓名</div>
					<input class="feedback-input" v-model="formData.realname" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">性别</div>
					<div class="feedback-input-labels">
						<label @click="changeInfo('男', 'gender')">
							<input type="radio" name="sex" value="男" :checked="formData.gender === '男'"/>
							<span>男</span>
						</label>
						<label @click="changeInfo('女', 'gender')">
							<input type="radio" name="sex" value="女" :checked="formData.gender === '女'"/>
							<span>女</span>
						</label>
					</div>
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">出生日期</div>
					<input type="date"  class="feedback-input" v-model="formData.birthday" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">籍贯</div>
					<input class="feedback-input" v-model="formData.nativePlace" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">民族</div>
					<input class="feedback-input" v-model="formData.nation" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">宗教信仰</div>
					<input class="feedback-input" v-model="formData.religion" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">政治面貌</div>
					<input class="feedback-input" v-model="formData.politicalStatus" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">学历</div>
					<input class="feedback-input" v-model="formData.education" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">身体状况</div>
					<input class="feedback-input" v-model="formData.healthStatus" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">身份证</div>
					<input class="feedback-input" v-model="formData.idCard" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">志愿者编号</div>
					<input class="feedback-input" v-model="formData.volunteerSn" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title"><span class="color-error">*</span>手机号</div>
					<input class="feedback-input" v-model="formData.mobile" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">E-mail</div>
					<input class="feedback-input" v-model="formData.email" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">工作单位/院校</div>
					<input class="feedback-input" v-model="formData.workPlace" />
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">常驻地址</div>
					<textarea class="feedback-input" v-model="formData.address"></textarea>
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">特长</div>
					<div class="feedback-input-labels">
						<label @click="changeInfo($event, 'skills')" v-for="(item, index) in skillList" :key="index">
							<input type="checkbox" name="skills" :value="item.value" :checked="item.checked" />
							<span>{{item.value}}</span>
						</label>
					</div>
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">可服务区域</div>
					<div class="feedback-input-labels">
						<label @click="changeInfo(item, 'serviceArea')" v-for="(item, index) in serviceAreas" :key="index">
							<input type="radio" :value="item" name="serviceArea" :checked="formData.serviceArea === item" />
							<span>{{item}}</span>
						</label>
					</div>
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">可服务时间</div>
					<div class="feedback-input-labels">
						<label v-for="(item, index) in serviceTimes" :key="index" @click="changeInfo(item, 'serviceTime')">
							<input type="radio" :value="item" name="serviceTime" :checked="formData.serviceTime === item"></radio>
							<span>{{item}}</span>
						</label>
					</div>
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">志愿者经历</div>
					<textarea class="feedback-input" v-model="formData.experience"></textarea>
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title">对志愿者服务工作的建议</div>
					<textarea class="feedback-input" v-model="formData.advice"></textarea>
				</div>
				<div class="feedback-row">
					<div class="feedback-input-title"><span class="color-error">*</span>本人照片</div>
					<ss-upload :value="oldHeadImage" maxCount="1" tips="大小不能超过500kb" @change="uploadSuccess" @add="uploadAdd"></ss-upload>
				</div>
				<div style="display:flex;">
          <button class="submit-btn btn-primary" style="width: 130px" @click="updateVolunteer">提交反馈</button>
          <button class="submit-btn btn-primary" style="width: 130px" @click="back">返回</button>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
	import ssUpload from '@/components/ss-upload/ss-upload.vue'
	import { mapActions } from 'vuex'
	import { checkIdCard } from '@/utils'
  import {BASE_URL} from "@/config";
	let requireMsg = {
		realname: '姓名不能为空',
		mobile: '手机号码不能为空',
		// headImage: '请上传本人头像'
	}
	export default {
		components: {
			ssUpload
		},
		data() {
			return {
				formData: {},
				serviceAreas: ['大兴区', '全市范围', '不限'],
				serviceTimes: ['周内', '双休日', '均可'],
				skillList: [],
				headImageTemp: '',
				oldHeadImage: []
			}
		},
		computed: {
			disabled_(){
				return !(this.formData.realname && this.formData.mobile && this.formData.headImage)
			}
		},
		created() {
			this.volunteerStatus();
		},
		methods: {
			...mapActions('user', ['GetUserInfoHandle']),
			async volunteerStatus() {
				let res = await this.$http('volunteerStatus');
				if(res.code === 1){
					if(res.data === 1 || res.data === 2){
						this.$dialog.alert(res.data === 1 ? '您已报名，资料正在审核中，请耐心等待' : '您的资料已经审核通过，可参与志愿者活动', {
							okText: '我知道了'
						}).then(() => {
							this.$router.back();
						})
					}else{
						this.volunteerInfo();
					}
				}
			},
			uploadSuccess(e) {
				let fileUrl = e[0] ? e[0].fileUrl : '';
				this.changeInfo(fileUrl, 'headImage');
			},
			uploadAdd(e) {
				let fileUrl = e[0] ? e[0].fileUrl : '';
				this.headImageTemp = fileUrl;
			},
			async volunteerInfo() {
				let res = await this.$http('volunteerInfo');
				if(res.code === 1){
          res.data && res.data.skills && (res.data.skills = res.data.skills + ',');
					res.data && (this.formData = res.data);
					this.getUserInfo(res.data && res.data.skills || []);
					res.data && res.data.headImage && (this.oldHeadImage = [res.data.headImage]);
				}
			},
			changeInfo(e, pro) {
        // 单独处理多选
        if (pro === 'skills') {
          const item = e.target._value;
          if (item) {
            if (e.target.checked) {
              this.formData.skills = (this.formData.skills || '') + item + ',';
            } else {
              this.formData.skills = this.formData.skills.replaceAll(item + ',', '')
            }
          }
        } else {
          let val = this.$typeof(e) === 'String' ? e : e.target._value;
          this.$set(this.formData, pro, this.$typeof(val) === 'Array' ? val.join(',') : val);
        }
			},
			async getUserInfo(skills) {
				let data = await this.GetUserInfoHandle(false);
				if(data){
					this.skillList = data.skillList.map(o => {
						return {
							value: o,
							checked: skills.indexOf(o) !== -1
						}
					})
				}
			},
			async updateVolunteer() {
        console.log(this.formData)
        // 把特长的最后一个逗号去除
        if(this.formData.skills){
          this.formData.skills = this.formData.skills.substring(0,this.formData.skills.length - 1)
        }
				let isGoing = true;
				for(var key in requireMsg){
					if(!this.formData[key]){
						this.$toast(requireMsg[key]);
						isGoing = false;
						break;
					}
				}
				if(this.formData.idCard && !checkIdCard(this.formData.idCard)) return this.$toast('身份证格式不正确');
				if(!this.headImageTemp) return this.$toast('请上传本人照片');
				if(this.headImageTemp && !this.formData.headImage) return this.$toast('正在上传中');
				if(!isGoing) return ;
				let res = await this.$http('updateVolunteer', this.formData);
				console.log(res);
				if(res.code === 1){
					setTimeout(() => {
            this.$router.push({
              path: '/volunteerHome/joinUs'
            })
					}, 1000)
				}
			},
      back(){
        this.$router.push({
          path: '/volunteerHome/joinUs'
        })
      }
		},
	}
</script>

<style lang="scss">
	@import '@/assets/css/feedback.scss';
</style>
